/**
 * Retorna a configuração de coluna de status para tabelas de despesa,
 * com badge colorido conforme o status da despesa.
 */

import { STATUS_COLOR_PALETTE } from './statusColorPalette';

const statusColors = {
    paid: STATUS_COLOR_PALETTE.green,
    pending: STATUS_COLOR_PALETTE.yellow,
    overdue: STATUS_COLOR_PALETTE.red,
    partially_paid: STATUS_COLOR_PALETTE.orange,
    cancelled: STATUS_COLOR_PALETTE.grey,
};

export const expenseStatusCell = (row) => {
    const color = statusColors[row.status] || STATUS_COLOR_PALETTE.default;
    return (
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{
                display: 'inline-block',
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: color,
                flexShrink: 0,
            }} />
            {row.formattedStatus}
        </span>
    );
};
